import { atom } from 'recoil';
import { carAgeOfPrimaryUserSelector } from '../selectors/carAgeOfPrimaryUserSelector';

export const carAgeOfPrimaryUserAtom = atom<number>({
    key: 'carPrimaryUserAge',
    default: carAgeOfPrimaryUserSelector
});
